import React, { useMemo, useEffect } from "react";

import KWH18MSF111_A from "./new/KWH-18M-SF111_A";
import KWH18MSF111_B from "./new/KWH-18M-SF111_B";
import KWH18MSF112_SX from "./new/KWH-18M-SF112_SX";
import KWH18MSF112_DX from "./new/KWH-18M-SF112_DX";
import KWH18MSF113_SX from "./new/KWH-18M-SF113_SX";
import KWH18MSF113_DX from "./new/KWH-18M-SF113_DX";
import KWH18MSF114_SX from "./new/KWH-18M-SF114_SX";
import KWH18MSF114_DX from "./new/KWH-18M-SF114_DX";
import KWH18MSF115_SX_A from "./new/KWH-18M-SF115_SX_A";
import KWH18MSF115_SX_B from "./new/KWH-18M-SF115_SX_B";
import KWH18MSF115_DX_A from "./new/KWH-18M-SF115_DX_A";
import KWH18MSF115_DX_B from "./new/KWH-18M-SF115_DX_B";
import KWH18MSF116_SX from "./new/KWH-18M-SF116_SX";
import KWH18MSF116_DX from "./new/KWH-18M-SF116_DX";

const Component = (props) => {
  const { onXUpdate } = props;

  useEffect(() => {
    if (props?.final)
      onXUpdate({ x: 20 * (props?.final?.central?.data?.length || 2), y: 0 });
  }, [props.final?.footer?.file]);
  switch (props.final?.footer?.file) {
    case "KWH-18M-SF111_A":
      return <KWH18MSF111_A {...props}></KWH18MSF111_A>;
      break;
    case "KWH-18M-SF111_B":
      return <KWH18MSF111_B {...props}></KWH18MSF111_B>;
      break;
    case "KWH-18M-SF112_SX":
      return <KWH18MSF112_SX {...props}></KWH18MSF112_SX>;
      break;
    case "KWH-18M-SF112_DX":
      return <KWH18MSF112_DX {...props}></KWH18MSF112_DX>;
      break;
    case "KWH-18M-SF113_SX":
      return <KWH18MSF113_SX {...props}></KWH18MSF113_SX>;
      break;
    case "KWH-18M-SF113_DX":
      return <KWH18MSF113_DX {...props}></KWH18MSF113_DX>;
      break;
    case "KWH-18M-SF114_SX":
      return <KWH18MSF114_SX {...props}></KWH18MSF114_SX>;
      break;
    case "KWH-18M-SF114_DX":
      return <KWH18MSF114_DX {...props}></KWH18MSF114_DX>;
      break;
    case "KWH-18M-SF11d_DX":
      return <KWH18MSF114_DX {...props}></KWH18MSF114_DX>;
      break;
    case "KWH-18M-SF115_SX_A":
      return <KWH18MSF115_SX_A {...props}></KWH18MSF115_SX_A>;
      break;
    case "KWH-18M-SF115_SX_B":
      return <KWH18MSF115_SX_B {...props}></KWH18MSF115_SX_B>;
      break;
    case "KWH-18M-SF115_DX_A":
      return <KWH18MSF115_DX_A {...props}></KWH18MSF115_DX_A>;
      break;
    case "KWH-18M-SF115_DX_B":
      return <KWH18MSF115_DX_B {...props}></KWH18MSF115_DX_B>;
      break;
    case "KWH-18M-SF116_SX":
      return <KWH18MSF116_SX {...props}></KWH18MSF116_SX>;
      break;
    case "KWH-18M-SF116_DX":
      return <KWH18MSF116_DX {...props}></KWH18MSF116_DX>;
      break;

    default:
      return <KWH18MSF111_A {...props}></KWH18MSF111_A>;
      break;
  }
};

export default function Footer(props) {
  const { final, update, position, rotation } = props;

  return (
    <>
      <Component
        wallcolor={final.wallcolorhex}
        covercolor={final.covercolorhex}
        tinsmithcolorhex={final.tinsmithcolorhex}
        position={position}
        rotation={rotation}
        final={final}
        onXUpdate={update}
      ></Component>
    </>
  );
}
